import React, { createContext, useState, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import WpAPI from "../WpApi";
import { ACCOUNT_SYNC } from "../constants/constants";
import { setMembershipData } from "../services/actions/actions";

const UserContext = createContext({});

export const UserProvider = ({ children }) => {
    const dispatch = useDispatch();
    const [plan, setPlan] = useState(null);
    const [lastsync, setLastsync] = useState(0);
    const [user, setUser] = useState(null);

    useEffect(() => {
        //on page load, plan will be set from api
        if(plan == null) fetchMembership();
    });

    const checkMembership = (callback, forcechange = false) => {
        //get the current plan of the user if plan is expired or force to change the plan
        if(((parseInt(lastsync)+parseInt(ACCOUNT_SYNC)) <= (Math.floor(Date.now() / 1000))) || forcechange){
            // fetchMembership().then(res => {
            //     //if callback is set and it is a function, execute it
            //     if(typeof callback == 'function') callback();
            // });
            fetchMembership();
            if(typeof callback == 'function') callback();

        }
        //plan is set in state and will be served from here only. NO api request is required.
        else{
            //if callback is set and it is a function, execute it
            if(typeof callback == 'function') callback(); 
        }
    }

    //get the user's current plan from api
    const fetchMembership = () => {
        return WpAPI.isLoggedIn() ?  WpAPI.getLoginUserInfo().then(res => {
                setPlan('pro')
                //set lastsync
                setLastsync(Math.floor(Date.now() / 1000));
                //set user
                setUser(res.data.user);
                const currentAccount = {plan: 'pro', 
                    lastsync: Math.floor(Date.now() / 1000), 
                    has_plan: true,
                    plan_has_trial: false,
                    plan_status: 'active'
                }
                dispatch(setMembershipData(currentAccount));
        }) : setPlan(null)
        // return WpAPI.membership(
        //     dispatch, 
        //     plan, 
        //     lastsync, 
        //     (p, u) => {
        //         //set plan
        //         setPlan(p);
        //         //set lastsync
        //         setLastsync(Math.floor(Date.now() / 1000));
        //         //set user
        //         setUser(u);
        //     },
        //     true
        // );
    }

    return (
        <UserContext.Provider value={{ checkMembership, plan, user }}>
            {children}
        </UserContext.Provider>
    );
}

export const useUser = () => {
    const context = useContext(UserContext);
    return context;
}